export interface CertifiedItem {
  nameCertificate: string;
  idCertificate: string;
  cohort: string;
  typeModule: ModuleType;
}


export interface EmailCertificationResponse {
email: string;
items: CertifiedItem[];
certificatNumber: number;
}

export enum ModuleType {

CERTIFIED='CERTIFIED',
ENHANCED='ENHANCED',
INSERTED='INSERTED'
}

export interface CertificationView {
  idCertificate: string;
  nameCertificate: string;
  cohort: string;
  certified: boolean;
  enhanced: boolean;
  inserted: boolean;
}

export enum CourseType {
  PARCOURS = 'PARCOURS',
  HORS_PARCOURS = 'HORS_PARCOURS',
  COURSERA = 'COURSERA',
  
}